import React, { Component } from 'react';
import {USER_COLORS} from 'common/js/params';
import './index.styl';

const clzpre = 'realname-percent';

class Percent extends Component{
    getPercentDom(obj, total, showNum) {
        const colorLen = USER_COLORS.length;
        return Object.entries(obj).map((item, i) => {
            const color = USER_COLORS[i % colorLen];
            const number = showNum ? <b style={{color}}>{item[1]}人</b>: '';
            const style = {
                width: `${100 * item[1]/total}%`,
                backgroundColor: color
            }
            return <p style={style} key={item[0]}><span>{item[0]}{number}</span></p>
        })
    }

    render(){
        const {total, working, htUser, ageUser} = this.props.data;
        const numStyle = {
            width: `${100 * working/total}%`,
            backgroundColor: USER_COLORS[0]
        }
        return <ul className={clzpre}>
            <li>
                <span>今日工作人数</span>
                <div>
                    <p style={numStyle}><span>{working}/{total}</span></p>
                </div>
            </li>
            <li>
                <span>工人年龄分布</span>
                <div>
                    {this.getPercentDom(ageUser, working)}
                </div>
            </li>
            <li>
                <span>籍贯分布</span>
                <div>
                    {this.getPercentDom(htUser, working)}
                </div>
            </li>
        </ul>
    }
}

export default Percent;